import * as constants from './Constants'
import { playClickSound } from './Sound'

// SceneWrapper is a null component.  Including/removing it is used as a way to force
// refresh of the A-Frame scene.
export function Alert(props) {
  if (props.alert === constants.ALERT_NONE) return null

  let text = ''

  // 4 buttons seems like too much t me - leave out "Cart"
  const button = {ok: true, cancel: true, checkout: true, cart: false}
  let onOK, onCancel, onCart, onCheckout

  switch (props.alert) {
    case constants.ALERT_EXIT:

      onCancel = () => {
        playClickSound()
        props.setAlert(constants.ALERT_NONE)
      }
      
      onCart = () => {
        playClickSound()
        props.updatePage(constants.REACT_PAGE_CART)
        props.setAlert(constants.ALERT_NONE)
      }


      onCheckout = () => {
        playClickSound()
        props.updatePage(constants.REACT_PAGE_FINAL_CHECKOUT)
        props.setAlert(constants.ALERT_NONE)
      }

      onOK = () => {
        playClickSound()
        props.updatePage(constants.REACT_PAGE_EXIT)
        props.setAlert(constants.ALERT_NONE)
      }

      if (props.itemCount > 0) {

        if (props.itemCount === 1) {
          text = `YOU HAVE 1 ITEM IN YOUR CART.  `
        }
        else {
          text = `YOU HAVE ${props.itemCount} ITEMS IN YOUR CART.  `
        }
        text += `  ARE YOU SURE YOU WANT TO EXIT?`
      } else {
        text = 'ARE YOU SURE YOU WANT TO EXIT?'
        button.checkout = false
        button.cart = false
      }
      break

      default:
        console.log('Unexpected alert')
        break
  }

  return (
    <>
      <div className='modal-wrapper'>
        <div className='modal'>
          <div className='modal-text'>
            {text}
          </div>
          <div className='modal-buttons'>
            {button.ok ? <div className='modal-button' onClick={onOK}>EXIT</div> : null}
            {button.cancel ? <div className='modal-button' onClick={onCancel}>CANCEL</div> : null}
            {button.cart ? <div className='modal-button' onClick={onCart}>CART</div> : null}
            {button.checkout ? <div className='modal-button' onClick={onCheckout}>CHECKOUT</div> : null}
          </div>
        </div>
      </div>
    </>
  )
}